export const storageKey = 'shopCustomLogoUrl';

export const getCustomLogoFromSession = (shopId?: string) => {
  const customLogoUrls = sessionStorage.getItem(storageKey);
  if (customLogoUrls) {
    return shopId
      ? (JSON.parse(customLogoUrls)?.[`${shopId}`] as string)
      : new Map<string, string>(Object.entries(JSON.parse(customLogoUrls)));
  }
  return undefined;
};

export const setCustomLogoToSession = (shopId: string, url: string) => {
  const listMap = getCustomLogoFromSession() ?? new Map<string, string>();
  (listMap as Map<string, string>).set(shopId, url);
  sessionStorage.setItem(
    storageKey,
    JSON.stringify(Object.fromEntries(listMap as Map<string, string>))
  );
};
